export enum HttpSuccessStatusCodes {
  Ok = 200,
  Created = 201,
  Accepted = 202,
  NoContent = 204,
}

export enum HttpErrorStatusCodes {
  WithoutResponse = 0,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  NotAllowed = 405,
  InternalServerError = 500,
  ServiceUnavailable = 503,
}

export type HttpStatusCodes = HttpSuccessStatusCodes | HttpErrorStatusCodes
